import Flickity from 'flickity'

var utils = require('fizzy-ui-utils');
var carousel = document.querySelector('.a-la-une-carousel');

if (carousel) {
  var flkty = new Flickity(carousel, {
    cellAlign: 'left',
    cellSelector: '.carousel-cell',
    resize: true,
    prevNextButtons: false,
    pageDots: true,
    autoPlay: 4000,
    wrapAround: true
  });

  // used for transition: the opacity was 0 before the carousel is loaded
  carousel.style.opacity = 1

  // previous
  var previousButton = document.querySelector('.button--previous');
  previousButton.addEventListener('click', function () {
    flkty.previous();
  });

  // next
  var nextButton = document.querySelector('.button--next');
  nextButton.addEventListener('click', function () {
    flkty.next();
  });

  // href hook: go to href on click on carousel cell
  flkty.on('staticClick', (event, pointer, cellElement) => {
    if (! cellElement) {
      return;
    }
    let targetArray = cellElement.querySelectorAll(':scope > a')
    if (targetArray.length && 0 in targetArray) {
      window.location = targetArray[0].href
    }
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/includes/home.js